import React from 'react'
import Modal from 'react-bootstrap/Modal'
import moment from 'moment'

import FetchHelper from "../../../utils/FetchHelper"

export default class EarningsDetail extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      loading: true,
      error: null,
      commissionData: null,
      referrerId: props.referrerId,
      currentPages: {},
      statusFilter: 'active'
    }
  }

  componentDidMount() {
    if (this.props.show && this.props.referrerId) {
      this._fetchCommissionDetails()
    }
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.show && nextProps.referrerId && nextProps.referrerId !== this.state.referrerId) {
      this.setState({ referrerId: nextProps.referrerId }, () => {
        this._fetchCommissionDetails()
      })
    }
  }

  _fetchCommissionDetails(status = null) {
    this.setState({ loading: true })

    const statusParam = status || this.state.statusFilter
    FetchHelper.get(`${window.Api.ReferralCommission}/${this.props.referrerId}?status=${statusParam}`, false)
      .then(response => {
        const currentPages = {}
        if (response.referrals) {
          response.referrals.forEach(referral => {
            currentPages[referral.referral_id] = 1
          })
        }
        this.setState({
          commissionData: response,
          loading: false,
          error: null,
          currentPages
        })
      })
      .catch(() => {
        this.setState({
          loading: false,
          error: 'Failed to load earning details'
        })
      })
  }

  _handleStatusChange = (event) => {
    const newStatus = event.target.value
    this.setState({ statusFilter: newStatus }, () => {
      this._fetchCommissionDetails(newStatus)
    })
  }

  _handlePageChange(referralId, newPage) {
    this.setState(prevState => ({
      currentPages: {
        ...prevState.currentPages,
        [referralId]: newPage
      }
    }))
  }

  _getPaginatedCommissions(commissions, referralId) {
    const pageSize = 10
    const currentPage = this.state.currentPages[referralId] || 1
    const startIndex = (currentPage - 1) * pageSize
    const endIndex = startIndex + pageSize
    return commissions.slice(startIndex, endIndex)
  }

  _renderPagination(referral) {
    const pageSize = 10
    const totalCommissions = referral.commissions.length
    const totalPages = Math.ceil(totalCommissions / pageSize)
    const currentPage = this.state.currentPages[referral.referral_id] || 1

    if (totalPages <= 1) return null

    const pages = []
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i)
    }

    return (
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div className="text-muted small">
          Showing {((currentPage - 1) * pageSize) + 1} to {Math.min(currentPage * pageSize, totalCommissions)} of {totalCommissions} users
        </div>
        <nav>
          <ul className="pagination pagination-sm mb-0">
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button
                className="page-link"
                onClick={() => this._handlePageChange(referral.referral_id, currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
            </li>
            {pages.map(page => (
              <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => this._handlePageChange(referral.referral_id, page)}
                >
                  {page}
                </button>
              </li>
            ))}
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button
                className="page-link"
                onClick={() => this._handlePageChange(referral.referral_id, currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    )
  }

  render() {
    let { loading, commissionData, error } = this.state

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title>Earning Details</Modal.Title>
            <div className="d-flex align-items-center" style={{ marginRight: '40px' }}>
              <label className="form-label mb-0 me-3 fw-bold text-dark">Status:</label>
              <select
                className="form-select form-select-sm border-2 border-primary"
                value={this.state.statusFilter}
                onChange={this._handleStatusChange}
                style={{
                  minWidth: '150px',
                  cursor: 'pointer',
                  fontWeight: '500'
                }}
              >
                <option value="active">Active</option>
                <option value="cancelled">Cancelled</option>
                <option value="all">All</option>
              </select>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {loading && (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          {!loading && !error && commissionData && (
            <>
              <div className="mb-4">
                <h5>Referrer Information</h5>
                <p><strong>Name:</strong> {commissionData.referrer_name}</p>
                <p><strong>Email:</strong> {commissionData.referrer_email}</p>
              </div>

              <h5 className="mb-3">Referral Breakdown</h5>

              {commissionData.referrals && commissionData.referrals.length > 0 ? (
                commissionData.referrals.map((referral) => (
                  <div key={referral.referral_id} className="mb-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h6 className="mb-2">Group Referral</h6>
                        <p className="mb-1"><strong>Code:</strong> {referral.share_code}</p>
                        <p className="mb-0"><strong>Pro Users:</strong> {referral.pro_users_count}</p>
                      </div>
                      <div className="text-end">
                        <h5 className="mb-0 text-primary">€{referral.earnings.toFixed(2)}</h5>
                        <small className="text-muted">Total Earnings</small>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-300 gy-3">
                          <thead>
                            <tr className="fw-bold text-muted">
                              <th>User Name</th>
                              <th>Email</th>
                              <th>Earning Rate</th>
                              <th>Status</th>
                              <th>Started On</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this._getPaginatedCommissions(referral.commissions, referral.referral_id).map((commission, idx) => (
                              <tr key={idx}>
                                <td>{commission.referred_user_name}</td>
                                <td>{commission.referred_user_email}</td>
                                <td>€{commission.commission_rate.toFixed(2)}</td>
                                <td className="text-capitalize">{commission.status}</td>
                                <td>{moment(commission.created_at).format('DD MMM YYYY')}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {this._renderPagination(referral)}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-muted">No referral details available</p>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.props.onHide}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}
